module.exports = __webpack_public_path__ + "static/media/package-tracking.ce53b56f.jpg";